import React, { ChangeEventHandler, memo, useState, useCallback, useEffect } from 'react';
import { Box, LinkProps } from '@chakra-ui/react';
import { colors } from 'theme/colors';
import { Button, TextField } from 'components';

interface IProps extends LinkProps {
  placeholder: string;
  // payload: IEvaluationProject;
  onChangeEvent?: ChangeEventHandler<HTMLInputElement>;
  isDetail?: boolean;
  // payload: any;
  obsValue?: string;
}

const AddObservationComponent: React.FC<IProps> = ({
  placeholder,
  obsValue,
  onChangeEvent,
  isDetail,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState<Boolean>(!!obsValue);
  const [value, setValue] = useState<string | undefined>(obsValue);
  const handleOpen = useCallback(() => {
    setIsOpen(o => !o);
  }, []);
  useEffect(() => {
    if (!isOpen) {
      setValue(undefined);
      if (onChangeEvent) {
        onChangeEvent({ target: { value: undefined } } as any);
      }
    }
  }, [isOpen]);
  return (
    <Box mt="10px" mb="10px">
      {isOpen ? (
        <TextField
          mb="8px"
          placeholder={placeholder}
          value={value}
          label="Observação"
          labelColor={colors.brand.tertiary}
          onChange={onChangeEvent}
          focusBorderColor={colors.brand[800]}
          disabled={isDetail}
        />
      ) : null}
      {!isDetail ? (
        <Button
          display="block"
          marginTop="15px"
          marginBottom="10px"
          fontSize="14px"
          // color={colors.brand[500]}
          // @ts-ignore
          outline
          disabled={isDetail}
          // @ts-ignore
          {...props}
          type="button"
          onClick={handleOpen}
          variant={!isOpen ? 'primary' : 'danger'}
        >
          {isOpen ? 'Remover Observação' : 'Adicionar observação'}
        </Button>
      ) : null}
    </Box>
  );
};

export const AddObservation = memo(AddObservationComponent);
